<template lang="pug">
  form(id="m1-payment-form" v-if="payment !== null")
      div.md-form-group(:class="{'invalid':errors.has('name')}")
          input.md-input(
              type="text"
              name="name"
              v-model="payment.name"
              v-validate="'required'"
              data-vv-as="Name"
              :disabled="loading"
              ref="paymentName"
          )
          label Name
          span.form-error-msg(v-show="errors.has('name')") {{ errors.first('name') }}

      div.md-form-group(:class="{'invalid':errors.has('sub_payment')}")
          select.md-input(
          v-model="payment.sub_payment"
          :disabled="loading"
          )
            option(v-for="type in types" :key="type.type" v-bind:value="type.type") {{ type.name }}
          label Mode

      div.md-form-group.p-t-0
          label.multiselect-label Applicable outlets
          multiselect(
          name="outlets"
          v-model="payment.outlets"
          :options="outletList"
          placeholder="Type to search"
          label="name"
          :multiple="true"
          :loading="outletList.length === 0"
          :disabled="loading"
          :clear-on-select="false"
          :close-on-select="false"
          :hide-selected="true"
          track-by="id"
          )
          span.md-input-msg Leave empty if applicable to all outlets.
      br
      div.md-form-group
          input.md-input(
              readonly
              type="text"
              placeholder="mobility_one"
          )
          label Source
</template>

<script>
import FormMixin from '../form-mixin';
import types from './m1-payment-types';

export default {
    mixins: [FormMixin],
    props: {
        payment: {
            type: Object,
            required: true,
            default: () => ({
                name: 'M1',
                type: 6,
                preset_amount: null,
                require_reference: true,
                source: 'm1_payment',
                meta: {},
                outlets: [],
            }),
        },
    },

    data() {
        return {
            types: types,
        };
    },
    methods: {
        mapPaymentValue() {
            let payment = _.pick(this.payment, ['id', 'meta']);

            return Object.assign(payment, {
                name: this.payment.name,
                outlets: this.payment.outlets.map(obj => obj.id),
                type: 6,
                preset_amount: null,
                require_reference: true,
                require_drawer_kick: false,
                sub_payment: this.payment.sub_payment,
                source: 'm1_payment',
            });
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/setting/payment/custom/m1-payment-form.vue